import ResourceModelBase from './lib/odd-resource_model';
export default ResourceModelBase;